import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { Button, Img, Modal } from "arv-reactcomponents";
import ApplicablePromosModal from "./ApplicablePromosModal";
import {
  ROUTE_PATHS,
  Checkout,
  Promotions as PROMOTIONS,
  MyBag,
} from "npmlinks-constants";
import { removePromoCode, setPromoCode } from "../../utils";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

@inject("PromotionsStore", "CheckoutStore")
@observer
class Promotions extends Component {
  static triggerPromoRemovalGa() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.PROMO_REMOVE,
    });
  }
  static triggerPromoFetchGA() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.PROMO_FETCH,
    });
  }
  constructor() {
    super();
    this.state = {
      currentMessage: null,
    };
    this.currentCouponCode = "";
    this.openPromoModal = this.openPromoModal.bind(this);
    this.closePromoPopup = this.closePromoPopup.bind(this);
    this.checkForPromoUpdate = this.checkForPromoUpdate.bind(this);
    this.toggleMessages = this.toggleMessages.bind(this);
  }
  componentDidUpdate() {
    this.checkForPromoUpdate();
  }
  get isCouponApplied() {
    const { pricingOverviewData = {} } = this.props.CheckoutStore;
    const { isCouponApplied = false } = pricingOverviewData;
    return isCouponApplied;
  }
  get currentTitle() {
    return this.isCouponApplied
      ? Checkout.CHECKOUT_MESSAGES.COUPON_TITLE.CHANGE
      : Checkout.CHECKOUT_MESSAGES.COUPON_TITLE.APPLY;
  }
  get isPromoButtonDisabled() {
    const { cartItems } = this.props.CheckoutStore;
    const {
      location: { pathname },
    } = window;
    if (pathname === ROUTE_PATHS.MYBAG) {
      return cartItems.some(product => product.sellableQty === 0);
    }
    return cartItems.some(
      product => !product.shippingMethod || product.sellableQty === 0,
    );
  }
  openPromoModal() {
    Promotions.triggerPromoFetchGA();
    this.props.PromotionsStore.setApplicablePromosModal(true);
  }

  closePromoPopup() {
    this.props.PromotionsStore.setApplicablePromosModal(false);
  }
  toggleMessages(message) {
    this.setState({
      currentMessage: message,
    });
    setTimeout(() => {
      this.setState({
        currentMessage: null,
      });
    }, Checkout.CHECKOUT_CONFIG.PROMO_MESSAGE_TIMEOUT);
  }
  checkForPromoUpdate() {
    const {
      pricingOverviewData: { couponCode },
    } = this.props.CheckoutStore;
    if (
      couponCode &&
      this.isCouponApplied &&
      couponCode !== this.currentCouponCode
    ) {
      this.props.PromotionsStore.setSelectedPromo(couponCode);
      this.currentCouponCode = couponCode;

      setPromoCode(couponCode);
      this.toggleMessages(Checkout.CHECKOUT_MESSAGES.COUPON_MESSAGE.SUCCESS);
    } else if (!this.isCouponApplied) {
      if (this.currentCouponCode) {
        Promotions.triggerPromoRemovalGa();
        const { removeSuccess } = this.props.PromotionsStore;
        const message = removeSuccess
          ? Checkout.CHECKOUT_MESSAGES.COUPON_MESSAGE.REMOVE
          : Checkout.CHECKOUT_MESSAGES.COUPON_MESSAGE.INVALID;
        this.props.PromotionsStore.setRemoveSuccess(false);
        this.toggleMessages(message);
      }
      this.currentCouponCode = "";
      removePromoCode();
    }
  }
  render() {
    const { pricingOverviewData } = this.props.CheckoutStore;
    const { currentMessage } = this.state;
    if (this.isPromoButtonDisabled) return null;
    return (
      <div>
        <Button
          className="nwc-btn nw-applypromo-btn"
          onClick={() => this.openPromoModal()}
        >
          <Img
            className="nw-applypromo-btnimg"
            src={PROMOTIONS.APPLY_PROMO_IMAGE}
            alt={MyBag.MYBAGPAGE.ALT_IMG_TEXT}
          />
          <span className="nw-applypromo-btntext">{this.currentTitle}</span>
        </Button>
          <div className="nw-applypromo-message">{currentMessage}</div>
        <Modal
          isOpen={this.props.PromotionsStore.isModalOpen}
          onClose={this.closePromoPopup}
          className="nw-applipromo-modal"
        >
          <ApplicablePromosModal.component
            pricingOverviewData={pricingOverviewData}
          />
        </Modal>
      </div>
    );
  }
}

Promotions.wrappedComponent.propTypes = {
  CheckoutStore: PropTypes.shape({
    pricingOverviewData: PropTypes.shape({}).isRequired,
    cartItems: PropTypes.shape({}).isRequired,
  }).isRequired,
  PromotionsStore: PropTypes.shape({
    setRemoveSuccess: PropTypes.func.isRequired,
    removeSuccess: PropTypes.bool.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    setApplicablePromosModal: PropTypes.func.isRequired,
    selectedPromoName: PropTypes.string.isRequired,
    setSelectedPromo: PropTypes.func.isRequired,
  }).isRequired,
};

export { default as ApplicablePromosList } from "./ApplicablePromosList";
export { default as ApplicablePromosModal } from "./ApplicablePromosModal";
export { default as PromotionsList } from "./PromotionsList";

const getFinalComponent = component =>
  inject("PromotionsStore", "CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Promotions.wrappedComponent,
  component: Promotions,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Promotions/index.js